<template>
  <page-edicion title="Crear plantilla">
    <formulario :plantilla-contrato="plantillaContrato" :unidades-negocio-id="unidadesNegocioId" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import api from "@/services/plantillasContrato.js";

export default {
  components: { Formulario },
  data() {
    return {
      plantillaContrato: api.crear(),
      unidadesNegocioId: [],
    };
  },
  mounted() {},
  methods: {
    insertar(unidadesNegocioSeleccionadas) {
      var plantilla = {
        plantillaContrato: this.plantillaContrato,
        unidadesNegocio: unidadesNegocioSeleccionadas,
      };
      api.insertar(plantilla).then(() => {
        this.$router.push({ path: "/plantillasContrato" });
      });
    },
  },
};
</script>
